import { Avatar, Box, IconButton } from '@mui/joy';
import { motion, useReducedMotion } from 'framer-motion';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { API_URL } from '../../api';

function formatTime(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toDateString() === new Date().toDateString()
    ? date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })
    : date.toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' });
}
const photoUrl = value => value ? /^https?:\/\//i.test(value) || value.startsWith('data:') ? value : `${API_URL}${value.startsWith('/') ? '' : '/'}${value}` : undefined;

export default function ChatListItem({ chat, selected, onSelect, onEdit, showEditButton = false, index = 0 }) {
  const reduceMotion = useReducedMotion();
  const photo = photoUrl(chat.photo_url || (!chat.is_community && chat.participants?.[0]?.profile?.photo_file_path));
  const message = chat.last_message || chat.last_msg;
  const lastText = message?.content || message?.text || (message?.attachments?.length ? 'Вложение' : 'Начните разговор');
  const name = chat.display_name || chat.name || chat.participants?.[0]?.name || 'Без названия';
  return (
    <Box component={motion.article} className={`lv-chat-row${selected ? ' is-active' : ''}`}
      initial={reduceMotion ? false : { opacity: 0, y: 7 }} animate={{ opacity: 1, y: 0 }}
      transition={{ duration: reduceMotion ? 0 : 0.2, delay: reduceMotion ? 0 : Math.min(index * 0.025, 0.15) }}>
      <button className="lv-chat-row__open" type="button" onClick={() => onSelect(chat)} aria-label={`Открыть чат: ${name}`}>
        <Avatar src={photo} alt="" sx={{ '--Avatar-size': { xs: '48px', sm: '54px' }, flex: 'none', borderRadius: '18px', color: '#a269dc', background: 'linear-gradient(135deg,#f9e9f5,#eee7ff)' }}>
          {chat.is_community ? <GroupsRoundedIcon sx={{ color: 'inherit' }} /> : <PersonRoundedIcon sx={{ color: 'inherit' }} />}
        </Avatar>
        <span className="lv-chat-row__body">
          <span className="lv-chat-row__head"><strong>{name}</strong><time>{formatTime(message?.date_create || message?.datetime)}</time></span>
          <span className="lv-chat-row__preview">{lastText}</span>
          {chat.is_community && <span className="lv-chat-row__meta">Сообщество · {chat.member_count || 0} участн.{chat.city ? ` · ${chat.city}` : ''}</span>}
        </span>
        <ChevronRightRoundedIcon sx={{ color: '#b7a8c7', fontSize: 21, flex: 'none' }} />
      </button>
      {showEditButton && <IconButton aria-label={`Редактировать сообщество: ${name}`} onClick={() => onEdit(chat)} size="sm" sx={{ mr: 1, flex: 'none', borderRadius: '12px', color: '#8863a9', backgroundColor: '#f7f1ff', minWidth: 40, minHeight: 40 }}><EditRoundedIcon sx={{ color: 'inherit', fontSize: 18 }} /></IconButton>}
    </Box>
  );
}
